import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "@/hooks/useAdminAuth";

interface AdminRouteProps {
  children: ReactNode;
  roles?: string[];
}

export function AdminRoute({ children, roles }: AdminRouteProps) {
  const { isAuthenticated, isLoading, user, checkAuth } = useAdminAuth();
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    roles &&
    user &&
    !user.roles.some((userRole) => roles.includes(userRole))
  ) {
    return <UnauthorizedRedirect />;
  }

  return <>{children}</>;
}

function UnauthorizedRedirect() {
  useEffect(() => {
    toast.error("You do not have permission to access that page");
  }, []);

  return <Navigate to="/admin" replace />;
}
